const { PUBLIC_URL = '/home/public/' } = process.env

export const CreditCardContent = {
  creditCard: {
    titleText: 'The Priceline Rewards<sup>™</sup> Visa<sup>®</sup> Card',
    bodyText:
      '<b>Earn 10,000 bonus points</b> after spending $1,000 on purchases in the first 90 days – that’s enough to redeem for a $100 statement credit! Plus, 5X points earned on eligible Priceline purchases!*',
    buttonText: 'Learn More',
    image: `${PUBLIC_URL}assets/images/promos/card.jpg`,
    imageWebP: `${PUBLIC_URL}assets/images/promos/card.webp`,
    legalText:
      "*See <a href='https://www.barclaycardus.com/apply/action/tncContent?prodidreq=CCVVS75544'>Terms and Conditions</a> for details.",
    buttonLink:
      'https://www.pricelinevisa.com/apply/Landing.action?campaignId=2566&cellNumber=6&referrerid=HOMEPAGE'
  }
}

export const CreditCardPromoContent = {
  creditCard: {
    titleText: 'The Priceline Rewards<sup>™</sup> Visa<sup>®</sup> Card',
    bodyText:
      '<b>10,000 bonus points</b> earned after your first purchase — that’s enough to redeem for a $100 statement credit!  Plus, 5X reward points earned on eligible Priceline purchases!*',
    buttonText: 'Learn More',
    image: `${PUBLIC_URL}assets/images/promos/card.jpg`,
    imageWebP: `${PUBLIC_URL}assets/images/promos/card.webp`,
    legalText:
      "*See <a href='https://www.barclaycardus.com/apply/action/tncContent?prodidreq=CCVVS63168'>Terms and Conditions</a> for details.",
    buttonLink:
      'https://www.pricelinevisa.com/apply/Landing.action?campaignId=2267&cellNumber=10&referrerid=PTRPRLHPBA1217'
  }
}
